export default __webpack_public_path__ + "4567e6977bba02369a348c066e0439b7.png";